import tippy from 'tippy.js';

function ToolTip() {
  tippy('.tooltip', {
    arrow: true,
    placement: 'top'
  });
}

export default ToolTip;


// WEBPACK FOOTER //
// ./src/js/app/components/ToolTip.js